/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
    const TARGET_ID = "56101602230655";
    let isFixing = false;

    // Polling every 500ms
    setInterval(function() {
        if (isFixing) return;

        // 1. Get Qty from DOM Input (Visual State)
        // Try multiple selectors to be sure we find it
        let $input = $(`.cart-item input[data-quantity-variant-id="${TARGET_ID}"]`);
        if ($input.length === 0) {
             // Try searching by value
             $input = $(`.cart-item input[value="${TARGET_ID}"]`).closest('.cart-item').find('input.quantity__input');
        }

        // If not found in DOM, we can't do much visually
        if ($input.length === 0) return;

        const currentQty = parseInt($input.val());

        // 2. THE CHECK
        if (currentQty > 1) {
            console.log("🚨 CRITICAL: Found " + currentQty + " gifts. Engaging Emergency Fix.");
            isFixing = true;
            
            // A. Visual Masking (Make it look fixed immediately)
            $input.val(1);
            
            // B. Disable Checkout (Prevent user leaving)
            $('button[name="checkout"], #CartDrawer-Checkout').prop('disabled', true).text('Syncing...');

            // C. Server Fix + Force Refresh
            $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/change.js',
                dataType: 'json',
                data: { id: TARGET_ID, quantity: 1 },
                success: function(cart) {
                    console.log("✅ Fixed on Server.");
                    
                    // D. TRIGGER REFRESH
                    // We try to fetch the drawer HTML manually and replace it
                    $.get(window.Shopify.routes.root + '?section_id=cart-drawer', function(data) {
                        const $newDrawer = $(data).find('#CartDrawer');
                        if ($newDrawer.length > 0) {
                             $('#CartDrawer').replaceWith($newDrawer);
                             console.log("✅ Drawer HTML Replaced.");
                             
                             // Re-enable checkout
                             $('button[name="checkout"], #CartDrawer-Checkout').prop('disabled', false).text('Check out');
                             isFixing = false;
                        } else {
                            // Fallback if section fetch fails: Reload Page
                            location.reload();
                        }
                    });
                },
                error: function() {
                    // If fix fails, reload page as last resort
                    location.reload();
                }
            });
        }
    }, 200);

  // GB: Variables
  let isUpdating = false; // Semaphore to prevent infinite loops

  function forceUpdateQuantity(variantId, newQty) {
    if (isUpdating) return; // Don't spam API
    isUpdating = true;
    console.log(`GB Force: Setting ${variantId} to ${newQty}...`);
    
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 'id': String(variantId), 'quantity': newQty })
    })
    .then(res => res.json())
    .then(cart => {
       console.log("GB Force: Done.", cart);
       
       // Reload Drawer
       if (typeof fetchCartDrawer === 'function') fetchCartDrawer();
       else {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
       }
       
       // Release lock after a delay to allow UI to settle
       setTimeout(() => { isUpdating = false; }, 2000); 
    })
    .catch(err => {
       console.error(err);
       isUpdating = false;
    });
  }

  function checkAndEnforceFreeGift() {
    if (isUpdating) return; 

    // 1. Get ID
    const input = document.querySelector(".free_product_progress_bar_variant");
    const FREE_GIFT_ID = input ? input.value : null;
    if (!FREE_GIFT_ID) return;

    // 2. Get Total (DOM)
    let cartTotal = 0;
    const totalEl = document.querySelector(".gb-totals-total-value");
    if (totalEl) {
        cartTotal = parseInt(totalEl.innerText.replace(/[^0-9]/g, '') || '0');
    }

    // 3. Threshold
    const threshold = parseInt(document.querySelector('[data-treshold-product]')?.getAttribute('data-treshold-product') || '0');

    // 4. API Check
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
         const finalTotal = Math.max(cartTotal, cart.total_price);
         if (finalTotal === 0 && cart.item_count > 0) return; 

         const giftItem = cart.items.find(item => item.variant_id == FREE_GIFT_ID);
         let currentQty = giftItem ? giftItem.quantity : 0;
         
         // === GB FIX: CHECK DOM ALSO ===
         // If API says 0, but DOM shows the item, TRUST DOM to prevent double-add
         // We look for the quantity input for this specific variant
         const domQtyInput = document.querySelector(`.cart-item input[data-quantity-variant-id="${FREE_GIFT_ID}"]`);
         if (currentQty === 0 && domQtyInput) {
             console.log("GB Check: API says 0 but DOM found item. Assuming Qty 1.");
             currentQty = parseInt(domQtyInput.value || 1);
         }
         // ==============================

         console.log(`GB Check: Total ${finalTotal} | Threshold ${threshold} | Gift Qty ${currentQty}`);

         // RULE 1: STRICTLY ENFORCE QUANTITY 1
         if (currentQty > 1) {
             console.log("GB Logic: Qty > 1 detected. Fixing...");
             forceUpdateQuantity(FREE_GIFT_ID, 1);
             return;
         }

         // RULE 2: Add if eligible
         if (finalTotal >= threshold) {
             if (currentQty === 0) {
                 console.log("GB Logic: Eligible. Adding.");
                 $(".gb-free-product-trigger").click();
             }
         }
         // RULE 3: Remove if not eligible
         else {
             if (currentQty > 0) {
                 console.log("GB Logic: Not eligible. Removing.");
                 forceUpdateQuantity(FREE_GIFT_ID, 0);
             }
         }
      });
  }


  // --- TRIGGERS ---
  if (document.querySelector('[data-treshold-product]')) {
      setTimeout(checkAndEnforceFreeGift, 2000);
      
      const observer = new MutationObserver((mutations) => {
          if (window.gbCheckTimeout) clearTimeout(window.gbCheckTimeout);
          window.gbCheckTimeout = setTimeout(checkAndEnforceFreeGift, 1500); 
      });
      
      const drawer = document.getElementById('CartDrawer');
      if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  }

// ... Rest of code

  $("body").on(
    "click",
    ".gb-shipping-protection-button label.switch",
    async (e) => {
      if (e.target.tagName == "INPUT") return;
      const curElem = document.querySelector(
        ".gb-shipping-protection-button label.switch"
      );
      const curInputElem = document.querySelector(
        ".gb-shipping-protection-button label.switch input"
      );
      const spinAnim = document.querySelector(
        ".gb-shipping-protection-button .spin-animation"
      );
      const checkElem = document.querySelector(
        ".gb-shipping-protection-button .complete-check"
      );
      if (curElem.classList.contains("unchecked") && !curInputElem.checked) {
        if (spinAnim.style.display == "block" || curInputElem.checked) return;

        // $(".gb-product-shipping-protection-product-tirgger").trigger("click");
        const form = document.querySelector("form.shipping-protection-form");

        const formData = new FormData(form);
        if (!formData.get("id")) {
          console.error(
            "There is no shipping protection product selected. Please select the shipping product in the global theme settings"
          );
          return;
        }

        spinAnim.style.display = "block";

        try {
          const response = await fetch(routes.cart_add_url, {
            method: "POST",
            body: formData,
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (response.ok) {
            spinAnim.style.display = "none";

            checkElem.style.display = "block";
          }
        } catch (err) {
          console.error("error at shipping protection form submission", err);
        }
        fetch(routes.cart_url + "?view=drawer")
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
                curElem.classList.remove("unchecked");
                curElem.classList.add("checked");
                curInputElem.checked = true;
              });
            }
          })
          .catch((_err) => {
            curElem.classList.remove("unchecked");
            curElem.classList.add("checked");
            curInputElem.checked = true;
          });
      } else if (
        curElem.classList.contains("checked") &&
        curInputElem.checked
      ) {
        checkElem.style.display = "none";
        const cartDrawer = document.querySelector("#CartDrawer");
        const removeButton = cartDrawer.querySelector(
          `cart-remove-button[data-id="${shippingProductId}"]`
        );
        const shippingItemIndex = removeButton?.dataset.index;
        if (!removeButton || !shippingItemIndex) {
          return;
        }

        const cartItems =
          cartDrawer.querySelector("cart-items") ||
          cartDrawer.querySelector("cart-drawer-items");

        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", () => {
          curElem.classList.remove("checked");
          curElem.classList.add("unchecked");
          curInputElem.removeAttribute("checked");
        });
      }
    }
  );

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    $(this)
      .closest(".gb-get-main-freq-pro")
      .find(".product-variant-id")
      .val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (
    e.target.matches(
      ".cart-drawer .gbfrequently-bought-with-main-whole .select__select"
    )
  ) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(
      parentBlock.querySelectorAll(".select__select")
    )
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) =>
      option.text.includes(allValues)
    );

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    const idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      console.log("Preventing submission - missing id parameter");
      e.preventDefault();
      return false;
    }
  }
});

// Improve cart quantity handlers
$(document).ready(function () {
  // Ensure all cart quantity changes include product ID
  $(".cart-item .quantity__button, .cart-item .quantity__input").on(
    "click change input",
    function () {
      const cartItem = $(this).closest(".cart-item");
      const variantId = $(this)
        .closest(".quantity-input")
        .find(".quantity__input")
        .data("quantity-variant-id");

      // If this is a form submission, ensure the ID is included
      if ($(this).closest("form").length > 0) {
        let idInput = $(this).closest("form").find('input[name="id"]');
        if (idInput.length === 0 && variantId) {
          console.log("Adding missing ID input to cart form");
          $("<input>")
            .attr({
              type: "hidden",
              name: "id",
              value: variantId,
            })
            .appendTo($(this).closest("form"));
        } else if (idInput.length > 0 && variantId) {
          idInput.val(variantId);
        }
      }
    }
  );

  // Add validation for cart drawer checkout button
  // Add validation for cart drawer checkout button (MODIFIED BY GB)
  $("#CartDrawer-Checkout").on("click", async function (e) {
    // 1. Stop the checkout immediately
    e.preventDefault();
    e.stopPropagation();

    const $btn = $(this);
    const originalText = $btn.text();
    $btn.prop('disabled', true).text('Verifying...');
    console.log("GB GUARD: Verifying cart before checkout...");

    try {
        // 2. Get the real cart state from the API
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await res.json();
        
        // Find the free gift ID from the script tag (must be available)
        const freeGiftId = typeof progressBarProductId !== 'undefined' ? progressBarProductId : null;
        if (!freeGiftId) {
             // If no ID, just proceed
             window.location.href = '/checkout';
             return;
        }
        
        const giftItem = cart.items.find(item => item.variant_id == freeGiftId);
        const currentQty = giftItem ? giftItem.quantity : 0;
        
        // 3. If quantity is wrong, fix it
        if (currentQty > 1) {
            console.log("GB GUARD: Fixing quantity from >1 to 1 before checkout.");
            await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'id': String(freeGiftId), 'quantity': 1 })
            });
        }
        
        // 4. Now that the cart is clean on the backend, proceed to checkout
        console.log("GB GUARD: Cart is clean. Proceeding to checkout.");
        window.location.href = '/checkout';

    } catch (err) {
        console.error("GB GUARD: Verification failed. Allowing checkout as a fallback.", err);
        $btn.prop('disabled', false).text(originalText);
        window.location.href = '/checkout'; // Fail-safe
    }
  });


  /**
   * * Prevent redirecting to checkout when pressing enter at quantity input
   */
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger("blur");
    }
  });
  // * End of handler
});

// Fix for frequently bought products add to cart
$(document).ready(function () {
  // Find all frequently bought product forms or buttons
  $(
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form"
  ).on("click", function (e) {
    const parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) {
      console.error(
        "Could not find parent block for frequently bought product"
      );
      return;
    }

    // Find the product ID input or data attribute
    let productId = null;

    // Check for direct ID input
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      const selectedOption = parentBlock.find(
        ".gb-change-variant_id option:selected"
      );
      if (selectedOption.length > 0) {
        productId = selectedOption.data("variant-id");
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find(".product-variant-id").length > 0) {
      productId = parentBlock.find(".product-variant-id").val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data("variant-id")) {
      productId = $(this).data("variant-id");
    }

    console.log("Frequently bought product add to cart - ID:", productId);

    if (
      this.classList.contains("gb-free-product-trigger") &&
      !show_progress_bar
    )
      return;

    // If no product ID found, prevent submission
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      console.log("Adding missing ID input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "id",
          value: productId,
        })
        .appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      console.log(
        "Adding default quantity input to frequently bought product form"
      );
      $("<input>")
        .attr({
          type: "hidden",
          name: "quantity",
          value: 1,
        })
        .appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});
